<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>机器人设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat :pairList="pairList" @refresh="handleSearch"></Creat>
        <el-select v-model="symbol" class='btn' clearable filterable placeholder="请选择交易对">
          <el-option v-for="item in pairList" :key="item.id" :label="item.symbol" :value="item.symbol">
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div>
        <List :currentPage="page" :currentSize="size" @refresh="handleSearch"></List>
        <PageNation :total="totalCount" :size="size" :page="page" @pageChanged="handlePageChanged($event)"></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState, mapMutations } from "vuex";
import Creat from "./components/create";
import List from "./components/list";
import PageNation from "../../../components/pagination";
import api from './api'
export default {
  name: "robotSotre",
  data() {
    return {
      symbol: "",
      total: 0,
      page: 1,
      size: 10,
      pairList: []
    };
  },
  components: {
    Creat,
    List,
    PageNation,
  },

  computed: {
    ...mapState("robotSotre", ["totalCount",]),
  },
  mounted() {
    this.getPairList()
    this.handleSearch()
  },
  methods: {
    ...mapActions("robotSotre", ["getlist"]),
    ...mapMutations("robotSotre", ["setPairList",]),
    getPairList() {
      api.getPairList().then((res) => {
        if (res.code == 0) {
          this.pairList = res.data;
          this.setPairList(res.data);
        }
      })
    },
    handleSearch() {
      this.getlist({
        page: this.page,
        size: this.size,
        symbol: this.symbol
      });
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.getlist({
        page: this.page,
        size: this.size,
        symbol: this.symbol
      });
    },
  },

};
</script>

<style lang="less" scoped></style>
